import { Router } from '@angular/router';
import { Grid } from '../../../../../shared/Models/grid';
import { PartsService } from '../../../../Services/parts.service';
import { TemplateRef } from '@angular/core';
import { createBasePartsGridConfig } from '../../../parts/configs/base-parts-grid.config';

export function createPartsModalGridConfig(
  router: Router,
  partsService: PartsService,
  partRowDetail: TemplateRef<any>,
  params: any
): Grid {
  return createBasePartsGridConfig({
    router,
    partsService,
    partRowDetail,
    defaultSort: 'position',
    multipleRowSearch: false,
    inPopUp: true,
    simpleSearch: true,
    showButton: false,
    params,
    includeItemColumn: true
  });
} 